import type { FC } from 'react'

import type { Locale, TranslationLang } from '@skytech/types'
import { LANGUAGE_FLAGS } from '@skytech/utils'
import { twJoin, twMerge } from 'tailwind-merge'

import { Button } from './Button'

export const availableLanguages: TranslationLang[] = ['en', 'dk', 'fi', 'se', 'no']

export const LanguageChoiceButtons: FC<{
  locale: Locale
  className?: string
  onChangeLocale: (locale: Locale) => void
}> = ({ locale, className, onChangeLocale }) => (
  <div className={twMerge('flex justify-end gap-x-2', className)}>
    {availableLanguages.map(lang => (
      <Button
        variant="tertiary"
        size="large"
        className={twJoin(
          'm-0 p-0 hover:no-underline',
          lang !== locale && 'opacity-40',
          lang === locale && 'pointer-events-none'
        )}
        key={lang}
        onClick={() => onChangeLocale(lang)}
      >
        <div className="text-4xl">{LANGUAGE_FLAGS[lang]}</div>
      </Button>
    ))}
  </div>
)
